/**
 * @desc 获取调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.stagingAreaMaster.getAllMasterByAono.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stagingAreaMaster/getAllMaster`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
